/**
 * Serviço para gerenciamento de autenticação e tokens
 */

// Armazena o token em localStorage para persistência entre recarregamentos
const getToken = () => {
  try {
    return localStorage.getItem('auth_token') || global.token || '';
  } catch (error) {
    console.error('Erro ao recuperar token:', error);
    return '';
  }
};

const setToken = (token) => {
  try {
    // Atualiza tanto o global quanto o localStorage
    global.token = token;
    localStorage.setItem('auth_token', token);

    // Dispara um evento para notificar outros componentes
    window.dispatchEvent(new Event('tokenUpdated'));

    return true;
  } catch (error) {
    return false;
  }
};

const clearToken = () => {
  try {
    global.token = '';
    localStorage.removeItem('auth_token');

    // Dispara um evento para notificar outros componentes
    window.dispatchEvent(new Event('tokenUpdated'));

    return true;
  } catch (error) {
    return false;
  }
};

// Inicializa o token global a partir do localStorage
const initToken = () => {
  const storedToken = localStorage.getItem('auth_token');
  if (storedToken) {
    global.token = storedToken;
  }
};

const authService = {
  getToken,
  setToken,
  clearToken,
  initToken
};

export default authService;
